<template>
	<div id='app'>
		<!-- <v-header :config="config" :userInfo="userInfo" v-if="$route.meta.header !== 'false'"></v-header> -->
		<!-- <keep-alive> -->
			<router-view></router-view>
		<!-- </keep-alive> -->
		<!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
		
    <div class="contact-box" v-if="isMobile">
      <div class="contact">
        <div class="contact-icon"></div>
        <div class="contact-text">咨询</div>
      </div>
      <a href="tel:0755-21650932"></a>
    </div>
	</div>
</template>
<script>
	import {mapState, mapMutations} from 'vuex';
	import header from "./components/header.vue";
	import api from "./utils/api";
	import Bus from "./utils/bus.js" 
	export default {
		watch:{
			'$route'(to,from){
				localStorage.removeItem('building_id')
				
				//全局监听路由改变时候的触发事件
				$("body").removeClass("viewer-open");
				$(".viewer-container").removeClass("viewer-in").addClass("viewer-hide");//切换路由的时候要关闭图片预览弹窗
				//有模型的页面不允许滚动
				if(this.$route.path.indexOf('/model') != -1  || this.$route.path == '/project'){

				}else if (this.$route.path == '/repairs') {
					$("body").css({'overflow-x':'hidden'})
				} else{
					$("body").css({'overflow':'auto'})
				}
				if(from.path.indexOf('/model') != -1 || from.path == '/project'){
					$('#loading1-div').remove();
					$("body").css({'overflow':'auto'})
					$('.global_loading_mask').remove()
					$('.global_loading_mask_fixed-container').remove()
				}
			}
		},
		components: {
			"v-header": header
		},
		data() {
			return {
				config: {
					num: "one"
				},
				userInfo: '',
				page_w: 1920,
				page_h: 877,
				isMobile: false,
			};
		},
		created() {
			this.page_h = window.innerHeight
			this.page_w = window.innerWidth
			
			if (this.page_w <= 750) {
				this.isMobile = true
			}
			
			this.getInfo()
			Bus._data._this = this
			this.getQueryString().then(res => {
				console.log('getQueryString res ', res)
				// debugger
				if (res.code) {
					let param = {
						code: res.code
					}
					api.getTokenOpenId(param).then(res => {
				// debugger
						console.log('this is get token open id res ', res)
						let result = res.data.result
						localStorage.setItem('web_token', result.web_token)
						localStorage.setItem("openid", result.openid);
						window.location.href = '/user?web_token='+result.web_token+'&openid='+result.openid;						
					})
				} else {
					// if (!res.openid) {return}
					// this.getLoginInfo(res);

					if (res.openid) {
						this.getLoginInfo(res);
					} 
					// else {
					// 	let web_token = localStorage.getItem('web_token')
					// 	let openid = localStorage.getItem("openid");
						
					// 	if (web_token && openid) {
					// 		let param = {
					// 			web_token: web_token,
					// 			openid: openid
					// 		}
					// 		this.getLoginInfo(param);
					// 	}					
					// }
				}				
				
			});
		},
		mounted() {
			//有模型的页面不允许滚动
			if(this.$route.path.indexOf('/model') != -1 || this.$route.path == '/project'){
				$("body").css({'overflow':'hidden'})
			}else{
				$("body").css({'overflow-x':'hidden'})
			}
			if (localStorage.getItem("user_info")) {
				this.userInfo = localStorage.getItem("user_info")
			}
			//窗口调整，发送广播
			window.onresize = function() {
				let param = {
					w: window.innerWidth,
					h: window.innerHeight
				}
				Bus.$emit('window-resize', param)
			}
		},
		methods: {		
			...mapMutations(['M_Home_Info']),	
			getInfo() {
				api.getNewHomeData({}).then(res => {
					console.log('getNewHomeData res ', res)
					if (res.data.code === 200) {
						let result = res.data.result;
						for (let k in result) {
							if (result[k] && result[k] instanceof Array) {
								result[k].forEach(item => {
									         
									if (item.content) {
										let content = ''
										try {
											content = decodeURIComponent(item.content)
										} catch(err) {
											console.log('解码失败')
										} finally {
											item.content = content
										}
									}
									if (item.picture) {
										if (item.picture.indexOf('https') == -1) {
											item.picture = item.picture.replace('http', 'https')
										}
									}
									if (item.icon) {
										if (item.icon.indexOf('https') == -1) {
											item.icon = item.icon.replace('http', 'https')
										}
									}
								})
							}
						}
						if (result.video.picture) {
							if (result.video.picture.indexOf('https') == -1) {
								result.video.picture = result.video.picture.replace('http', 'https')
							}
						}

						this.M_Home_Info(result)
					}
				})
			},
			//获取URL参数
			getQueryString() {
				console.log('app getQueryString ')
				return new Promise((resolve, reject) => {
					let search = decodeURI(window.location.search.substr(1));
					if (!search) {
						// resolve({})
						return false
					}
					let arr = search.split("&");
					let paramsObj = {};
					arr.forEach(item => {
						let temArr = item.split("=");
						paramsObj[temArr[0]] = temArr[1];
					});
					resolve(paramsObj);
				});
			},
			async getLoginInfo(param) {
				console.log('app getLoginInfo ')
				
				const res = await api.loginByToken(param);
				if (!res) {
					return
				}
				if (res.status === 200) {
					if (res.data.code === 200) {
						// Bus._data.tabVisible = true
						localStorage.setItem('web_token', param.web_token)
						localStorage.setItem("openid", res.data.result.openid);
						localStorage.setItem(
							"user_info",
							JSON.stringify(res.data.result.user_info)
						);
						localStorage.setItem("user_id", res.data.result.user_info.id);
						Bus.$emit('changeLoginStatus', true)
						this.userInfo = JSON.stringify(res.data.result.user_info)
					}
				}
			},

			//登录转态校验
			loginStatusCheck(_this) {
				_this = _this;
				return this.getQueryString().then(res => {
					if (!res.openid) {
						// _this.$alert('登录状态校验失败，请重新登录', '提示', {
						// 	confirmButtonText: '确定',
						// 	callback: action => {
						// 		let url = 'https://open.weixin.qq.com/connect/qrconnect?appid=wxa53287936b0890ee&redirect_uri=https%3a%2f%2fapi.smartfacade.com.cn%2fwechat%2fopenLogin%3ffrom%3dadmin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'
						// 		// window.open(url, '_self')
						// 		window.location.replace(url)
						// 	}
						// });
						return false;
					}

					// return res
					let local_openid = window.localStorage.getItem("local_openid");
					let local_web_token = window.localStorage.getItem("local_web_token");
					if (!local_openid || !local_web_token) {
						window.localStorage.setItem("local_openid", res.openid);
						window.localStorage.setItem("local_web_token", res.web_token);
						let time = new Date().getTime();
						window.localStorage.setItem("expire_time", time);
					} else {}
					return res;
				});
			}
		}
	};
</script>
<style>
@import url('./assets/css/caseIndex');
@import url('./assets/css/date-plugin.css');
	#app {
		position: absolute;
		top: 0;
		width: 100%;
	}
	.el-step__title {
		font-size: 13px !important;
		line-height: 50px;
	}

	
	.carousel-3d-container .prev > span, .carousel-3d-container .next > span {
		display: inline-block;
		text-align: center;
    width: 0.52rem;
		height:1.4rem;
		line-height: 1.4rem;
		font-size: 0.48rem !important;
		/* background:  center center no-repeat;
		background-size: cover; */
		color: #fff;
		background-color:rgba(0,0,0,0.7);
		/* display: flex;
    align-items: center;
    justify-content: center; */
	}
	.carousel-3d-container .prev > span span, .carousel-3d-container .next > span span {
		font-size: inherit;
	}
	.carousel-3d-container {
		overflow: visible !important;
	}
	.carousel-3d-slide.current {
		overflow: visible !important;
		box-shadow: 0px 0px 5px rgba(0,0,0,0.7) !important;
	}

	/* 报检报修 全局样式 */
	.el-input__inner{
		border: none !important;
		border-radius:0px !important;
		}
		.el-select-dropdown__list{
			padding: 5px 12px !important;
		}
		.el-radio__label {
				/* margin-left: 10px; */
				line-height: 30px;
				font-size: 20px;
				padding-left: 5px;
		}

		.el-upload-list--picture-card .el-upload-list__item {
			height: 100px;
			width: 100px;
		}
		.el-upload--picture-card {
			height: 100px;
			width: 100px;
			line-height: 100px;
		}


		/* 移动端 联系我们 */
		@import url('./assets/css/contact');

		
</style>



// WEBPACK FOOTER //
// src/App.vue